import CustomSelect from '../CustomSelect';
import { CopyIcon } from './Icons';
import { TYPE_CONFIG, STATUS_OPTIONS, KANBAN_STATUS_OPTIONS, PRIORITY_CONFIG } from '../../constants';
import { buildUserOptions } from '../../utils';

export default function MobileItemDetailView({ item, users, isKanban, onStatusChange, onAssigneeChange }) {
  const config = TYPE_CONFIG[item.type] || TYPE_CONFIG.task;
  const Icon = config.icon;
  const userOptions = buildUserOptions(users);

  return (
    <div className="mobile-item-detail">
      <div className="mobile-item-type" style={{ color: config.color }}>
        <Icon size={18} /> {config.label}
        {item.readableId && (
          <span
            className="sprint-item-rid sprint-item-rid--lg"
            onClick={() => navigator.clipboard.writeText(`${item.readableId}-${item.title}`)}
          >
            {item.readableId} <CopyIcon size={12} />
          </span>
        )}
      </div>
      <h3 className="mobile-item-title">{item.title}</h3>
      {item.description && <p className="mobile-item-desc">{item.description}</p>}
      <div className="mobile-item-meta">
        <CustomSelect
          value={item.status}
          onChange={(val) => onStatusChange(item.id, val)}
          options={isKanban ? KANBAN_STATUS_OPTIONS : STATUS_OPTIONS}
          size="sm"
          compact
        />
        {isKanban && item.priority && (
          <span className="priority-badge priority-badge--lg" style={{ background: PRIORITY_CONFIG[item.priority]?.color }}>
            {PRIORITY_CONFIG[item.priority]?.label}
          </span>
        )}
        {item.storyPoints != null && (
          <span className="sprint-item-points">{item.storyPoints} pts</span>
        )}
      </div>
      <div style={{ marginTop: '8px' }} onClick={(e) => e.stopPropagation()}>
        <CustomSelect
          value={item.assigneeId || ''}
          onChange={(val) => onAssigneeChange(item.id, val)}
          options={userOptions}
          size="sm"
          compact
        />
      </div>
    </div>
  );
}
